import { mapGetters, mapActions, mapState } from 'vuex'
import { forEach, keys, flatten, values } from 'lodash'
import globaltypes from '../../store/globaltypes'

export default {
  name: 'shoppingcart',
  components: {},
  props: [],
  data () {
    return {
      goToShop: false,
      hasSynced: false,
      selections: {},
      groupExpansions: {}
    }
  },
  computed: {
    ...mapState({
      isDataLoaded: state => state.ui.wishlist.isDataLoaded
    }),
    ...mapGetters({
      shoppingcart: globaltypes.shoppingcart.getters.shoppingcartitemsPerCategory,
      crop: globaltypes.crops.getters.cropById,
      product: globaltypes.products.getters.product,
      totalProducts: globaltypes.shoppingcart.getters.productCounter,
      syncing: globaltypes.shoppingcart.getters.isSycing,
      user: globaltypes.user.getters.currentUser,
      postIDLocale: globaltypes.i18n.getters.postIDLocale,
      allTranslationsPostIDs: globaltypes.i18n.getters.allTranslationsPostIDs,
      areProductsLoaded: globaltypes.products.getters.areProductsLoaded
    }),
    productPrice () {
      return line => `€ ${this.getPrice(line).toFixed(2)}`
    },
    price () {
      return line => `€ ${(this.getLineTotal(line)).toFixed(2)}`
    },
    total () {
      var total = this.lines.reduce((acc, line) => acc + this.getLineTotal(line), 0)
      return `€ ${total.toFixed(2)}`
    },
    lines () {
      return flatten(values(this.shoppingcart))
    },
    hasItemWithVarieties () {
      return this.lines
        .map(x => this.product(x.productID))
        .filter(x => !!x)
        .map(x => x.varieties)
        .filter(x => !!x && x.length).length > 0
    },
    isLoading () {
      if (!this.isDataLoaded) return true
      return !this.areProductsLoaded(this.lines.map(x => x.productID))
    }
  },
  activated () {
    this.loadProducts(this.lines.map(line => line.productID))
  },
  methods: {
    ...mapActions({
      deleteProductLine: globaltypes.shoppingcart.actions.deleteProduct,
      updateLine: globaltypes.shoppingcart.actions.updateLine,
      infrom: globaltypes.main.actions.setInformation,
      sendOrder: globaltypes.shoppingcart.actions.placeOrder,
      openCart: globaltypes.shoppingcart.actions.openCart,
      loadProducts: globaltypes.products.actions.loadList
    }),
    placeOrder () {
      var productIDs = keys(this.selections).filter(x => this.selections[x] && this.postIDLocale(x) === this.$store.state.user.locale)
      this.sendOrder(productIDs)
      this.$ga.event({
        eventCategory: 'Product',
        eventAction: 'Order placed',
        eventLabel: `${this.totalProducts} products added to cart`
      })
    },
    removeProductLine (line) {
      this.deleteProductLine(line.key)
      this.$ga.event({
        eventCategory: 'Product',
        eventAction: 'product deleted from wishlist',
        eventLabel: `${this.totalProducts} products deleted from wishlist`
      })
    },
    changeLine (line, variationID) {
      line.variationID = variationID
      this.updateLine(line)
    },
    takeMeToTheShop () {
      this.openCart()
      this.goToShop = false
    },
    continuePlanning () {
      this.$router.push({ name: 'wizard' })
    },
    update () {
    },
    getPrice (line) {
      var price = 0
      if (this.product(line.productID)) {
        price = (this.product(line.productID).price || 0) * 1
        if (line.variationID && this.product(line.productID).varieties && this.product(line.productID).varieties.length) {
          var variation = this.product(line.productID).varieties.filter(x => x.ID === line.variationID)[0] || this.product(line.productID).varieties[0]
          price = variation.price * 1
        }
      }
      return price
    },
    getLineTotal (line) {
      if (this.product(line.productID)) {
        return (this.getPrice(line) * line.quantity || 0)
      } else {
        return 0
      }
    },
    toggleCategoryExpansion (categoryID) {
      this.$set(this.groupExpansions, categoryID, !this.groupExpansions[categoryID])
    },
    toggleSelection (productID) {
      const val = !this.selections[productID]
      this.allTranslationsPostIDs(productID).forEach(ID => this.$set(this.selections, ID, val))
    }
  },
  watch: {
    syncing: function (val) {
      if (val) {
        this.hasSynced = true
      } else if (!val && this.hasSynced) {
        this.goToShop = true
      }
    },
    shoppingcart: function (val, pval) {
      forEach(val, group => forEach(group, product => {
        this.$set(this.selections, product.productID, (product.productID in this.selections) ? this.selections[product.productID] : true)
      }))
      this.loadProducts(this.lines.map(line => line.productID))
    }
  }
}
